import EventBus from '../../../../service/EventBus'

export const functionMixin = {
  methods: {
    changeBreadCrumb(pageName) {
      EventBus.$emit('breadCrumb', this.changeDataByType(pageName))
    },
    changeDataByType(pageName) {
      this.dataBreadCrumd[2] = {
        name: pageName == 'DocumentType' ? 'Lĩnh vực' :
              pageName == 'DocumentOrganizationModel' ? 'Mô hình tổ chức' :
              pageName == 'DocumentGroup' ? 'Nhóm' :
              pageName == 'DocumentBusiness' ? 'Ngành' : '',
        path: '',
      }
      return this.dataBreadCrumd
    },
  },
}
